/**
 * Send analytics events relating to actions on table
 */

import window from 'window-or-global';
import { bind, trigger, unbind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { getOverride } from '@confluence/meta';

let editor;

function onChangeTableMode() {
	trigger('analytics', {
		name: `confluence.table.mode.to.${getTableMode()}`,
		data: { pageId: getOverride('page-id') },
	});
}

function onCopyRow() {
	trigger('analytics', {
		name: 'confluence.table.row.copy',
		data: { pageId: getOverride('page-id') },
	});
}

function onPasteRow() {
	trigger('analytics', {
		name: 'confluence.table.row.paste',
		data: { pageId: getOverride('page-id') },
	});
}

function onCopyCol() {
	trigger('analytics', {
		name: 'confluence.table.col.copy',
		data: { pageId: getOverride('page-id') },
	});
}

function onPasteCol() {
	trigger('analytics', {
		name: 'confluence.table.col.paste',
		data: { pageId: getOverride('page-id') },
	});
}

/**
 * Send analytics if an image is pasted into a table
 * @param insertContent
 * @private
 */
function onInsertContent(insertContent) {
	/**
	 * CONFDEV-37491
	 * insertContent might be special chars OR html
	 * to avoid error 'Syntax error, unrecognized expression', create a <div> and set content using .html()
	 */
	const $container = $('<div/>').html(insertContent);

	//check if image is pasted into a table
	if ($container.find('img').length && isInsideTable()) {
		eventInsertImage();
	}

	//check if table is pasted
	if ($container.find('table.confluenceTable').length) {
		trigger('analytics', {
			name: 'confluence.table.paste',
			data: { pageId: getOverride('page-id') },
		});
	}
}

function onSetContent(args) {
	if ($('<div/>').html(args.content).find('.confluence-embedded-image').length) {
		eventInsertImage();
	}
}

function onResizeImg(data) {
	const isImgBiggerThanCell = function () {
		const $img = $(editor.selection.getNode());
		const $cell = $img.closest('th, td');
		return $img.width() > $cell.width();
	};
	if (data && data.name && data.name.indexOf('confluence.editor.image.resize') >= 0) {
		trigger('analytics', {
			name: 'confluence.table.img.resize',
			data: {
				pageId: getOverride('page-id'),
				tableMode: getTableMode(),
				isImgBiggerCell: isImgBiggerThanCell(),
			},
		});
	}
}

function eventInsertImage() {
	trigger('analytics', {
		name: 'confluence.table.image.insert',
		data: {
			pageId: getOverride('page-id'),
			tableMode: getTableMode(),
		},
	});
}

function isInsideTable() {
	return !!$(editor.selection.getNode()).closest('table.confluenceTable').length;
}

function getTableMode() {
	const $table = $(editor.selection.getNode()).closest('table.confluenceTable');
	if ($table.hasClass('fixed-table')) {
		return 'fixed';
	}
	if ($table.hasClass('relative-table')) {
		return 'relative';
	}
	return 'fluid';
}

function onSavePage() {
	//get all tables in the page
	const $tables = $(editor.getBody()).find('table.confluenceTable');
	trigger('analytics', {
		name: 'confluence.table.quality.in.page',
		data: {
			pageId: getOverride('page-id'),
			total: $tables.length,
			fixed: $tables.filter('.fixed-table').length,
			fluid: $tables.filter(':not(.fixed-table,.relative-table)').length,
			relative: $tables.filter('.relative-table').length,
			nested: $tables.find('table.confluenceTable').length,
		},
	});
}

const TableAnalytics = {
	init(ed) {
		editor = ed;
		ed.on('ExecCommand', (obj) => {
			switch (obj.command) {
				case 'mceAutoWidth':
				case 'mceRelativeWidth':
				case 'mceFixedWidth':
					onChangeTableMode();
					break;
				case 'mceTableCopyRow':
					onCopyRow();
					break;
				case 'mceTablePasteRowBefore':
				case 'mceTablePasteRowAfter':
					onPasteRow();
					break;
				case 'mceTableCopyCol':
					onCopyCol();
					break;
				case 'mceTablePasteColBefore':
				case 'mceTablePasteColAfter':
					onPasteCol();
					break;
				//copy-paste
				case 'mceInsertContent':
					onInsertContent(obj.value);
					break;
			}
		});

		//insert image by drag-drop OR via dialog OR using '!'
		ed.on('Init', () => {
			ed.selection.onSetContent.add((selection, args) => {
				if (isInsideTable() && args) {
					onSetContent(args);
				}
			});
		});

		function analyticsEventHandler(e, data) {
			if (isInsideTable()) {
				onResizeImg(data);
			}
		}
		//listen to analyticsEvent which is fired when resizing image
		bind('analyticsEvent', analyticsEventHandler);

		//listen to reliable save success
		bind('rte.safe-save.success', onSavePage);

		//CONFDEV-55148
		ed.on('Remove', () => {
			unbind('analyticsEvent', analyticsEventHandler);
			unbind('rte.safe-save.success', onSavePage);
		});
	},

	getInfo() {
		return {
			longname: 'Table Analytics Plugin',
			author: 'Atlassian',
			authorurl: 'http://www.atlassian.com',
			version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
		};
	},
};

export default function () {
	window.tinymce.create('tinymce.plugins.TableAnalytics', TableAnalytics);
	window.tinymce.PluginManager.add('tableAnalytics', window.tinymce.plugins.TableAnalytics);
}
